import {Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {BundeslandEnumLabels, Finanzamt} from '@nachdigal';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {finanzamtMap} from './finanzamtMap';
import {KeyValue} from '@angular/common';

@Component({
  selector: 'common-ui-finanzamt',
  templateUrl: './finanzamt.component.html'
})
export class FinanzamtComponent extends FormBaseComponent<Finanzamt> {

  public bundeslandEnum = BundeslandEnumLabels;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  public get filteredFinanzamtMap(): Map<number, string> {
    return new Map<number, string>([...finanzamtMap.entries()].filter((entry: [number, string]) => {
      const selectedBundeslandKey = this.form.get('bundesland').value;
      const entryKey = entry[0];
      return entryKey.toString().startsWith(selectedBundeslandKey);
    }));
  }

  public sortByValue(a: KeyValue<number, string>, b: KeyValue<number, string>): number {
    return a.value.localeCompare(b.value);
  }

  protected createForm(): void {

    this.form = this.formBuilder.group({
      bundesland: [
        this.data.bundesland, [
          this.validatorService.required()
        ]
      ],
      finanzamtnummer: [
        this.data.finanzamtnummer, [
          this.validatorService.required()
        ]
      ]
    });
  }
}
